<template>
  <div id="app" @mousemove="moveSpotlight">
    <header>
      <div class="demo-row">
        <nav class="navbar navbar-inverse" role="navigation">
          <div class="navbar-header">
            <router-link to="/about" class="logo-wrapper">
              <!--<span class="logo">&nbsp;</span>-->
              <img :src="contestLogo">
            </router-link>
          </div>
          <div class="collapse navbar-collapse header-menu-link">
            <ul class="nav navbar-nav navbar-route menu-ul">
              <li><router-link to="/about">{{about_}}</router-link></li>
              <li><router-link to="/news">{{news_}}</router-link></li>
              <li><router-link to="/challenge">{{challenge_}}</router-link></li>
              <li><router-link to="/trend">{{trend_}}</router-link></li>
              <li><router-link to="/scoreboard"  >SCOREBOARD</router-link></li>
              <li v-if="ctfMode == 'teams'"><router-link to="/team/_" v-if="!gameOver && profile.name">MY TEAM</router-link></li>
              <!-- <li><router-link to="/countdown">{{countdown_}}</router-link></li> -->
             <li v-show="!gameOver && !profile.name"><router-link to="/login">{{login_}}</router-link></li>
              <li class="dropdown" v-if="!gameOver && profile.name">
                <a class="dropdown-toggle" data-toggle="dropdown"><span class="glyphicon glyphicon-user"></span>{{profile.uid}} <span class="caret"></span></a>
                <!-- Dropdown-menu -->
                <ul class="dropdown-menu">
                  <li v-if="ctfMode == 'teams'"><router-link to="/team/_" v-if="!gameOver && profile.name">{{myTeam_}}</router-link></li>
                  <li><router-link to="/profile">{{profile_}}</router-link></li>
                  <li><router-link to="/changePwd">{{changePwd_}}</router-link></li>
                  <li><a @click="logout">{{logout_}}</a></li>
                </ul>
              </li>
            </ul>
            <ul class="nav navbar-nav navbar-info menu-countdow">
              <li>
                <a style='color:#fff; cursor:auto;'>
                  <span v-if='gameOver'>{{gameOver_}}</span>
                  <span v-if='!gameOver'>{{isBegun ? timeLeft_ : countdown_}} <span style="color: #00c8e3;padding-left: 15px">{{countDown}}</span></span>
                </a>
              </li>
              <li><a class="logos-wrapper" href="mailto:info@realworldctf.com"><span class="logoemail">&nbsp;</span></a></li>
              <li><a target="_blank" class="logos-wrapper" href="https://twitter.com/RealWorldCTF"><span class="logotwitter">&nbsp;</span></a></li>
              <!--<li class="dropdown">-->
                <!--<a class="dropdown-toggle" data-toggle="dropdown"><span class="glyphicon glyphicon-globe"></span><span class="caret"></span></a>-->
                <!--<ul class="dropdown-menu">-->
                  <!--<li v-for="(language, key) in languages"><a @click="setLocale(key)">{{language.__name__}}</a></li>-->
                <!--</ul>-->
              <!--</li>-->
            </ul>
          </div><!-- /.navbar-collapse -->

        </nav><!-- /navbar -->
      </div> <!-- /row -->
    </header>
    <div :class="['message-box', {hide: !(info || warning || error)}]">
      <div class="alert alert-success" v-if="info">{{info}}</div>
      <div class="alert alert-warning" v-if="warning">{{warning}}</div>
      <div class="alert alert-danger" v-if="error">{{error}}</div>
    </div>
    <!-- /header -->
    <div class="mycontainer hasBg">
      <div class="bg-top"></div>
      <div class="spotlight2" :style="{left: spotlight.left + 'px', top: spotlight.top + 'px'}"></div>
    </div>
    <div class="mycontainer">
      <router-view :key="$route.fullPath" @msg="showMsg"/>
    </div>
    <div class="footer">
      <p>ROOM 2-008, Block A West, 768 Creative Industry Park, Xueyuan Rd NO. 5A, Haidian District, Beijing, China</p>
      <p>COPYRIGHT © 2018-2024 CHAITIN TECH ALL RIGHTS RESERVED</p>
      <div style="display: flex; justify-content: center; color: #8e8e8e; padding-top: 8px;">
        <p>© 2024 北京长亭未来科技有限公司</p>
        <a target="_blank" rel="noreferrer" href="https://beian.miit.gov.cn/"
          style="padding-left: 8px; color: #8e8e8e;">京ICP备19035216号-6</a>
        <a target="_blank" rel="noreferrer"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020947"
          style="padding-left: 8px; color: #8e8e8e;">京公网安备 11010802020947号</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

import { getCookie } from '@/utils/cookies.js'
import { logout } from '@/utils/api.js'
import i18n from '@/i18n'
import { getCountDown } from '@/utils'

export default {
  name: 'app',
  data () {
    return {
      languages: i18n.locales,
      info: '',
      warning: '',
      error: '',
      spotlight: {
        left: 0,
        top: 0
      },
      countDown: '0:00:00',
      frameId: 0
    }
  },
  computed: {
    ...mapState(['profile', 'v_locale', 'endTime', 'startTime', 'ctfMode', 'now', 'timeDelta', 'contestLogo', 'theme']),
    ...mapGetters(['gameOver']),
    ...i18n.map([
      'about_', 'news_', 'challenge_', 'rank_table_',
      'trend_', 'scoreboard_', 'myTeam_', 'login_',
      'profile_', 'changePwd_', 'logout_', 'countdown_',
      'timeLeft_', 'gameOver_', 'days_'
    ]),
    isBegun () {
      return this.now > this.startTime
    }
  },
  methods: {
    ...mapMutations(['setLocale', 'updateNow']),
    moveSpotlight (e) {
      this.spotlight = {
        left: e.pageX - 180,
        top: e.pageY - 180 - (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0)
      }
    },
    logout,
    showMsg ({msg, type, delay, callback}) {
      type = type || 'info'
      if (delay) {
        this[type] = msg
        setTimeout(() => {
          this[type] = ''
          callback && callback()
        }, delay)
      }
    }
  },
  created () {
    this.profile.name = getCookie('uid')
  },
  mounted () {
    const updateCountdown = () => {
      this.updateNow()
      if (this.gameOver) return
      this.countDown = getCountDown(this.now < this.startTime ? this.startTime : this.endTime, this.days_)
    }
    this.frameId = setInterval(updateCountdown, 1000)
  },
  beforeDestroy () {
    clearInterval(this.frameId)
  }
}
</script>

<style lang="less">

  a {
    cursor: pointer;
  }
.header-menu-link{
  ul{
    padding: 0;
    margin: 0;
  }
}
.logo-wrapper{
  margin-left: 15px;
}
.menu-ul{
  display: flex;
  align-items: flex-end;
  li{
    line-height: 20px;
    a{
      padding-top: 0;
    padding-bottom: 0;
    }
  }
}
.menu-countdow{
  top: 25px;
  display: flex;
  align-items: flex-start;
  li{
    line-height: 20px;
    a{
      padding-top: 0;
    padding-bottom: 0;
    }
  }
}
  .dropdown {
    & .dropdown-menu {
      display: none !important;
    }
    &:hover {
      & .dropdown-menu {
        display: block !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/themes/dragon/App.vue